import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { LoadingState } from '../components/common/LoadingState';
import { useAuth } from '../hooks/useAuth';
import { useTenant } from '../hooks/useTenant';
import { getHostnameContext } from '../utils/hostname';

export function ProtectedRoute() {
  const { authenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) return <LoadingState />;
  if (!authenticated) return <Navigate to="/login" replace state={{ from: location }} />;
  return <Outlet />;
}

export function PublicRoute() {
  const { authenticated, loading } = useAuth();
  if (loading) return <LoadingState />;
  if (getHostnameContext().tenantSlug) return <Outlet />;
  if (authenticated) return <Navigate to="/dashboard" replace />;
  return <Outlet />;
}

export function StudentPublicRoute() {
  const { authenticated, loading } = useAuth();
  if (loading) return <LoadingState />;
  if (authenticated) return <Navigate to="/student/portal" replace />;
  return <Outlet />;
}

export function StudentProtectedRoute() {
  const { authenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) return <LoadingState />;
  if (!authenticated) return <Navigate to="/student/login" replace state={{ from: location }} />;
  return <Outlet />;
}

export function TenantRequiredRoute() {
  const { loading, memberships, activeTenant } = useTenant();

  if (loading) return <LoadingState />;
  if (!memberships.length) return <Navigate to="/setup" replace />;
  if (!activeTenant) return <LoadingState label="Opening organization..." />;
  return <Outlet />;
}

export function SetupRoute() {
  const { loading, memberships } = useTenant();
  if (loading) return <LoadingState />;
  if (memberships.length) return <Navigate to="/dashboard" replace />;
  return <Outlet />;
}
